export { LocalStorageModule } from './local-storage.module';
export { LocalStorageService } from './local-storage.service';
export { ILocalStorageServiceConfig } from './local-storage.config.interface';
export { INotifyOptions } from './notify-options.interface';
